import React, { useState } from "react";
import ReactSelect from "react-select";
import { useStyles } from "./useStyles";

export const CustomSelect = ({
  key,
  value,
  options,
  onChange,
  isClearable,
  customStyles,
  isMulti
}) => {
  const [isSearchable] = useState(true);
  return (
    <ReactSelect
      key={key}
      value={value}
      isClearable={isClearable}
      isSearchable={isSearchable}
      options={options}
      onChange={onChange}
      isMulti={isMulti}
      styles={customStyles || useStyles}
    />
  );
};

